"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EChatEvents = void 0;
var EChatEvents;
(function (EChatEvents) {
    EChatEvents["NEW_MESSAGE"] = "messages.new";
    EChatEvents["LOAD_MESSAGES"] = "messages.load.all";
    EChatEvents["ACTIVE_USERS"] = "users.online";
    EChatEvents["TYPING"] = "chat.typing";
    EChatEvents["ENTER_ROOM_CHAT"] = "room.join";
    EChatEvents["MARK_AS_READ"] = "chat:markAsRead";
    EChatEvents["NOTIFICATION_NEW_MESSAGE"] = "notification.new.message";
    EChatEvents["NOTIFICATION_NEW_CONTACT"] = "notification.new.contact";
})(EChatEvents || (exports.EChatEvents = EChatEvents = {}));
